import Select from 'react-select';
import { Image } from '@/shared/ui/image';
import styled from 'styled-components';

export const OptionWrapper = styled.div`
  display: flex;
  gap: 8px;
  z-index: ${(props) => (props.$isSelected ? 1 : 0)};
  background: ${(props) => {
    if (props.$isSelected) {
      return '#27262B';
    } else if (!props.$isDisabled) {
      return 'none';
    } else {
      return '#3D3C41';
    }
  }};
  border-radius: ${(props) => (props.$isSelected ? '8px' : 'inherit')};
  opacity: ${(props) => (props.$isDisabled ? 1 : 0.5)};
  cursor: ${(props) => (!props.$isDisabled ? 'not-allowed' : 'pointer')};

  justify-content: flex-start;
  padding: 8px;
  padding-right: 12px;
  position: relative;
  align-items: center;
  margin-bottom: 2px;
  padding: 8px;

  @media (max-width: 768px) {
    justify-content: space-between;
  }

  &:hover {
    background: #625a63;
    border-radius: 8px;
  }

  ${({ $haveDrawer, $isSelected }) =>
    $haveDrawer &&
    `
margin:0;
padding:20px 12px;
height:60px;
border-radius:0;

`}
`;
export const SelectWrapper = styled.div`
  min-width: 140px;
  cursor: pointer;
  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const CategoryText = styled.div`
  color: #edeff5;
  opacity: 0.6;
  text-shadow: 0px 1px 1px rgba(18, 22, 32, 0.4);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

export const EllipsisWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: bottom;
  text-transform: capitalize;
  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 160px;
    overflow: hidden;
  }
  div {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
  }
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    border-radius: 8px;
    flex-basis: 140px;
    height: 48px;
    background: #625a63;

    z-index: 0;
    padding: 6px 12px;
    overflow: hidden;
    cursor: pointer;

    @media (max-width: 768px) {
      /* padding: 0; */
      height: 42px;
      padding: 0 11px;
      flex-basis: 100%;
    }
  }

  .react-select__value-container {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .react-select__control:hover {
    border-radius: 8px;
    opacity: 0.9;
    box-shadow: 0px 0px 12px 0px #625a63 inset;
  }
  .react-select__control:active {
    opacity: 0.9;
  }
  .react-select__indicator {
    position: absolute;
    right: 10px;
    top: 10px;

    @media (max-width: 768px) {
      top: 12px;
      right: 8px;
    }
  }
  .react-select__menu-list {
    padding: 6px;
  }

  .react-select__indicators {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .react-select__menu {
    z-index: 1000;
  }

  .react-select__menu {
    border-radius: 8px;
    margin-top: 4px;
    border-radius: 8px;
    width: 240px;
    max-height: 380px;
    z-index: 100;
    overflow: hidden;
    background: #3d3c41;
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  }
`;

export const ControlWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 8px;
    gap: 8px;
  }
`;

export const ImageControlWrapper = styled.div`
  display: flex;
  img {
    filter: brightness(0) invert(1);
  }
`;
export const OptionText = styled.div`
  color: #edeff5;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-transform: capitalize;
`;

export const ImageOption = styled(Image)`
  position: relative;
  filter: ${(props) => props.$isActive && 'brightness(0) invert(.9)'};
`;
export const OptionCheck = styled.div`
  position: absolute;
  right: 12px;
  top: 10px;
`;

export const OptionCount = styled.span`
  color: #afafaf;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-left: 4px;
`;

export const CategoryDrawerTextWrapper = styled.div`
  ${({ $haveDrawer }) =>
    $haveDrawer &&
    `
padding:0 16px;
padding-top:16px;
margin-bottom:12px;
`}
`;

export const OptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  gap: 2px;
  margin: 0 12px;
  border-radius: 12px;
`;

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
`;
